import { Subscription } from 'rxjs/Subscription';
import { UserManagerProvider } from './../../providers/user-manager/user-manager';
import {CircleProgressComponent} from '../../components/circle-progress/circle-progress';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';

import { WebSocketService } from '../../services/webSocketService';
import { RestService } from '../../services/restService';
import { UserProfile } from '../../model/UserProfile';
import 'rxjs/add/operator/share';
import { Constants } from '../../util/Constants';
import { Util } from '../../util/Util';

/**
 * Generated class for the MenuPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
})
export class MenuPage {

  @ViewChild ('scoreCircle') scoreCircle : CircleProgressComponent;
  @ViewChild ('profitabilityCircle') profitabilityCircle : CircleProgressComponent;
  @ViewChild ('accuracyCircle') accuracyCircle : CircleProgressComponent;
  @ViewChild ('mycontent') mycontentNav: NavController;

  rootPage = "TabPage";
  userProfile: UserProfile = new UserProfile(0, "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1, false, false);
  connectionStatusSubscription: Subscription;
  version = Constants.VERSION;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public menuCtrl: MenuController, public restService: RestService,
    public webSocketService: WebSocketService,
    public userManager: UserManagerProvider) {}

  goToKinballPage(pageName) {
    this.navCtrl.push(pageName);
    this.menuCtrl.close();
  }

  goToKintipsPage(pageName) {
    window.location.href = Util.getKintipsUrl() + "#/" + pageName;
    this.menuCtrl.close();
  }

  goToWeb(sUrl) {
    let win = window.open(sUrl, '_blank');
    win.focus();
    this.menuCtrl.close();
  }

  /* initWebSocket() {
    console.log("initWebSocket");

    return new Promise < void > (
      (resolve, reject) => {
          this.connectionStatusSubscription = this.webSocketService.connectionStatusSubject.asObservable().share().distinctUntilChanged().subscribe(isConnected => {
          if (isConnected) {
            this.connectionStatusSubscription.unsubscribe();
            resolve();
          }
        });

       if (!this.userManager.isLoggedIn()) {

          setTimeout(() => {
            let loginModal = this.modalCtrl.create(LoginPage, {}, {
              enableBackdropDismiss: false
            });
            loginModal.present();

          }, 500);
        } else {
          try {
            this.webSocketService.connectWS();
          } catch (err) {
            reject();
            console.log(err);
            //this.userManager.logout();
            //location.reload();
          }
        }
      }
    );

  } */



  logout() {
    this.userManager.logout();
    this.webSocketService.destroy();
    this.navCtrl.popToRoot();
  }

  isLoggedIn(): boolean {
    return this.userManager.isLoggedIn();
  }


/*
  ionViewCanEnter(): Promise < void > {
    // here we can either return true or false
    // depending on if we want to leave this view
    return this.initWebSocket();
  }
*/



  ionViewDidLoad() {
    //this.initWebSocket();
  }

  ionViewDidEnter() {
    this.webSocketService.connectionStatusSubject.asObservable().share().distinctUntilChanged().subscribe( isConnected => {
      if (isConnected) {
        /*
        this.mycontentNav.setRoot("TabPage").catch(err => {
          console.log("Set tab page as root failed");
        });;
        */
        this.webSocketService.getTipsterInfoObj(this.userProfile);
      }
    });

    /*
    if (this.webSocketService.isConnected()) {
        this.webSocketService.getTipsterInfoObj(this.userProfile);
        return;
      }

      if (!this.userManager.isLoggedIn()){
        this.navCtrl.push("LoginPage");
      } else {
        try {
          this.webSocketService.connectWS();
          this.webSocketService.getTipsterInfoObj(this.userProfile);
        } catch (err) {
          console.log(err);
          this.userManager.logout();
          location.reload();
        }

      }
      */
  }

  ionViewWillLeave() {
    if (this.connectionStatusSubscription) {
      this.connectionStatusSubscription.unsubscribe();
    }
  }

  showTipsterInfo(tipsterId) {
    this.navCtrl.push("TipsterInfoPage", {
      "tipsterId": tipsterId
    });
    this.menuCtrl.close();
  }


}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts